var _path;
import * as React from "react";
var SvgArrowScrollDown = function SvgArrowScrollDown(props) {
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,16l-8,8L4,16V8l4.67,4.67V0h6.66V12.67L20,8Zm-.67-.28V9.61l-4.66,4.67V.67H9.33V14.28L4.67,9.61v6.11L12,23.06Z"
  }));
};
export default SvgArrowScrollDown;